
$(document).ready(function(){
$('.instagram-slider,.instagram_section').slick({
    dots: false,
    arrows: true,
    slidesToShow:6,
    slidesToScroll:1,
    infinite: false,
    speed: 300,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        slidesToScroll:3
      }
    },
    { 
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    { 
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll:2
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
  
//   ====================================
  $('.review_div').slick({
            dots: true,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 1,
            vertical: false,
            focusOnSelect: false,
            verticalSwiping: false,
            dots: false,
            arrows: false,
            infinite: true,
    nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
            responsive: [{
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
              }
            }, {
              breakpoint: 481,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                 dots: true,
              }
            }
                         // You can unslick at a given breakpoint now by adding:
                         // settings: "unslick"
                         // instead of a settings object
                        ]
          });
  
//   ===================================
  
  
$(window).width();
  if ($(window).width() < 900) {
      $('.mobile-icons-slider').slick({
      dots: false,
      arrows: false,
      slidesToShow: 4,
      slidesToScroll:1,
      infinite: false,
      speed: 300,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll:1
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll:1,
            dots: true
          }
        }
      ]
    });
     $('.slick_mobile').slick({
      dots: false,
      arrows: false,
      slidesToShow: 2,
      slidesToScroll:2,
      infinite: false,
      speed: 300,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll:2
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll:1,
            centerMode: true,
        centerPadding: '100px',
             infinite: true
          }
        }
      ]
    });
    
$('.slider-one').slick({
  dots: true,
  adaptiveHeight:true,
  infinite: false,
    arrows: false,
  speed: 300,
  responsive: [
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
    $('.slider-insta').slick({
  dots: false,
  adaptiveHeight:true,
  infinite: true,
  
   
    arrows: false,
  speed: 300,
  responsive: [
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1.2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1.2,
        slidesToScroll: 1    

      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
     $('.slider-two').slick({
      dots: false,
      arrows: false,
      slidesToShow: 2,
      slidesToScroll:2,
      infinite: false,
      speed: 300,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll:2
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll:1,
            centerMode: true,
        centerPadding: '50px',
             infinite: true
          }
        }
      ]
    });
    
  }
  
  
  $('.featured_slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>"
  });
  
  $('.product-div').slick({
  dots: false,
      arrows: true,
     prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
    slidesToShow: 4,
    slidesToScroll:1,
  infinite: false,
  speed: 300,
  responsive: [
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 2,
        slidesToScroll:2
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        dots: true,
        slidesToShow: 2,
        slidesToScroll:1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
  setTimeout(function(){
  $('.sixteencolumns').slick({
    dots: false,
    arrows: true,
    slidesToShow:4,
    slidesToScroll:1,
    infinite: false,
    speed: 300,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll:2
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll:2
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
    },1000);
  $('.container_menu').click(function(){
    $('.mobile-header-menu').slideToggle();
    $('.overlayclas').toggle();
//    if($('.mobile-header-menu').is(':visible'))
// {
// $('.overlayclas').fadeIn();
// }else{
// $('.overlayclas').hide();
// }
  })
  $('.searchs a').click(function(){
  $('.container_menu').trigger('click');
  })
  $('.overlayclas').click(function(){
$('.mobile-header-menu').slideToggle();
    $('.overlayclas').hide();
    $('.container_menu').removeClass('change');
  })
});


function decrementCurrentValue()

{
    var currentValue=document.getElementById("cifri").value;
    var intCurrentValue=parseInt(currentValue);
    intCurrentValue=intCurrentValue-1;
    if(intCurrentValue<1){intCurrentValue=1;}
    document.getElementById("cifri").value=intCurrentValue;
 
    
    
}

function incrementCurrentValue()

{
    var currentValue=document.getElementById("cifri").value;
    var intCurrentValue=parseInt(currentValue);
    intCurrentValue=intCurrentValue+1;
    document.getElementById("cifri").value=intCurrentValue;

    
    
}

$(document).ready(function() {
  //toggle the component with class accordion_body
  $(".accordion_head").click(function() {
    if ($('.accordion_body').is(':visible')) {
      $(".accordion_body").slideUp(300);
      $(".plusminus").text('+');
    }
    if ($(this).next(".accordion_body").is(':visible')) {
      $(this).next(".accordion_body").slideUp(300);
      $(this).children(".plusminus").text('+');
    } else {
      $(this).next(".accordion_body").slideDown(300);
      $(this).children(".plusminus").text('-');
    }
  });
  
  
//  Quantity selector
  $('.quantys-secondary .qtyplus').click(function(){
    var value = $('.quant-add #cifri').val();
    $(this).prev('#cifri').val(value);
  })

  $('.quantys-secondary .qtyminus').click(function(){
    var value = $('.quant-add #cifri').val();
    $(this).prev('#cifri').val(value);
  })
  
  
   
          $('.product-single__thumbnails').not('.slick-initialized').slick({
            dots: true,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 3,
            vertical: true,
            focusOnSelect: true,
            verticalSwiping: true,
            dots: false,
            centerPadding: '100px',
            arrows: true,
            infinite: true,
          prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left aaa' aria-hidden='true'></i></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
            responsive: [{
              breakpoint: 1024,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
              }
            }, 
                          {
              breakpoint: 480,
              settings: {
                 arrows: false,
                adaptiveHeight: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                vertical: false,
                verticalSwiping: false,
              }
            }
                         // You can unslick at a given breakpoint now by adding:
                         // settings: "unslick"
                         // instead of a settings object
                        ]
          });
  
});



 $(document).ready(function(){
  setTimeout(function(){
  $('.background-slideshow').slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 3,
    arrows:true,
    prevArrow:"<button type='button' class='slick-prev pull-left'> <i class='fa fa-angle-left'></i></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'> <i class='fa fa-angle-right'></i></i></button>",
      responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
    
});
     $('.is-selected').trigger('click');
    $('.background-slideshow img').bind("click", function(){
      var src= $(this).attr('src');
      var href= $(this).attr('data-href');
      $(this).parents('.spf-product-card').find('.spf-product-card__image-wrapper').attr('href',href);
      $(this).parents('.spf-product-card').find('.spf-product-card__image').attr('src',src);
    })
     $('.background-slideshow').css('opacity','1');
    
     $('.star-review').each(function(){
     var url = $(this).attr('data-href');
       console.log(url);
     var element = this;
     $.ajax({
       type:"GET",
       url: url,
       cache: false,
       success: function(data){
         var result = $(data).find('.product-single__hero .jdgm-widget').html();
         $(element).html(result);
       }
     });
   });
    
    
    
    },2000);
     $('.button_and_quantity').addClass('fixed-cart');
  
 });


/*** fixed header ***/
$(window).scroll(function(){
    if ($(window).scrollTop() >= 20) {
        $('.header-header').addClass('fixed-header');
    }
    else {
        $('.header-header').removeClass('fixed-header');
    }
});

/*** fixed mobile header ***/
$(window).scroll(function(){
    if ($(window).scrollTop() >= 20) {
        $('.mobile-header').addClass('fixed-header');
    }
    else {
        $('.mobile-header').removeClass('fixed-header');
    }
});
$(window).scroll(function(){
    if ($(window).scrollTop() >= 900) {
        $('.stickybar').addClass('fixed-bar');
    }
    else {
        $('.stickybar').removeClass('fixed-bar');
    }
});



/*** fixed cart ***/
// $(window).scroll(function(){
//     if ($(window).scrollTop() > ) {
//         $('.button_and_quantity').addClass('fixed-cart');
//     }
//     else {
//         $('.button_and_quantity').removeClass('fixed-cart');
//     }
// });
// $(".btn--search").click(function(){
//   event.preventDefault();
//   $(".style-search form input").toggleClass("full");
// });




// ==============Mobile menu==============
 if ($(window).width() < 768) {
$('.site-nav--has-dropdown > a').click(function(e){
e.preventDefault();
$(this).toggleClass('activemen');
$(this).next('.site-nav__dropdown').slideToggle();
})
 }



// --******************************************************---

$(document).ready(function(){
    $('.Details').on('click', function(e) {
      e.preventDefault()
      $('html, body').animate({
          scrollTop: $('.common-only').offset().top-100,
        },500,'linear')
    });
    
     
     $('.Spec').on('click', function(e){
  e.preventDefault()
 $('html, body').animate({
      scrollTop: $('.tab-only').offset().top-130,
    },500,'linear')
});
     $('.Review').on('click', function(e) {
  e.preventDefault()
  $('html, body').animate({
      scrollTop: $('.reviews-only').offset().top-130,
    },500,'linear')
});
     
    });

// --******************************************************--



// =============================================================mini cart============================================================

function success(){
 
  $.ajax({
    url: "/cart",
    type: 'GET',
    dataType: 'html',
    success: function(response) {
      $('.mini_cart').html('');
      var result = $(response).find('.cart_data');
      
      $('.mini_cart').html(result);
      $('.mini_cart').show();

    }
  });
//   $(document).on("focusout",".quant_div .cart__quantity-selector",function(){
//        $(this).next('.udpate_clas').trigger('click');
//     });

  $('.minus_udpate_clas').click(function(){
 var value = $(this).parents('.quant_div').find('.cart__quantity-selector').val();
     if(value > 1){
var value = parseInt(value) - parseInt(1);
$(this).parents('.quant_div').find('.cart__quantity-selector').val(value);
    $(this).parents('.plus-minus-update').next('.udpate_clas').trigger('click');
     }
})
  
  $('.plus_udpate_clas').click(function(){
var value = $(this).parents('.quant_div').find('.cart__quantity-selector').val();
   
var value = parseInt(value) + parseInt(1);
$(this).parents('.quant_div').find('.cart__quantity-selector').val(value);
 $(this).parents('.plus-minus-update').next('.udpate_clas').trigger('click');
    
})
}

function updatequant(){

  $('.minus_udpate_clas').click(function(){
 var value = $(this).parents('.quant_div').find('.cart__quantity-selector').val();
     if(value > 1){
var value = parseInt(value) - parseInt(1);
$(this).parents('.quant_div').find('.cart__quantity-selector').val(value);
    $(this).parents('.plus-minus-update').next('.udpate_clas').trigger('click');
     }
})
  
  $('.plus_udpate_clas').click(function(){
var value = $(this).parents('.quant_div').find('.cart__quantity-selector').val();
   
var value = parseInt(value) + parseInt(1);
$(this).parents('.quant_div').find('.cart__quantity-selector').val(value);
 $(this).parents('.plus-minus-update').next('.udpate_clas').trigger('click');
    
})
}


$(document).ready(function(){
  
updatequant();
  
  
  
//   $(document).on("focusout",".quant_div .cart__quantity-selector",function(){
//         $(this).next('.udpate_clas').trigger('click');
//     });
  
  
  
//   $('.cart-page-link').click(function(e){
//     e.preventDefault();
// $('.mini_cart').removeClass('extras');
//         $('.cart-overlays').show();
// })
  $('.close-cart-img').click(function(){
$('.cart-overlays').hide();
     $('.mini_cart').addClass('extras');
})
  
  $('#AddToCart').click(function(e){
     e.preventDefault();
     var old_this = $(this);
    $(old_this).val('Added');
   
   var var_id = $('.product-single__variants option:selected').val();
    var varaint_qt = $('input#cifri').val();
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      cache:false,
      data: {
        quantity: varaint_qt,
        id:var_id
      },
      dataType: "json",
      success: function (data) {
//         $('.mini_cart').removeClass('extras');
//         $('.cart-overlays').show();
        success();
       
        $('.minus_udpate_clas').click(function(){
         //  alert('minus');
 var value = $(this).parents('.quant_div').find('.cart__quantity-selector').val();
          if(value > 1){
var value = parseInt(value) - parseInt(1);
$(this).parents('.quant_div').find('.cart__quantity-selector').val(value);
    $(this).parents('.plus-minus-update').next('.udpate_clas').trigger('click');
          }
})
  
  $('.plus_udpate_clas').click(function(){
    //alert('plus');
var value = $(this).parents('.quant_div').find('.cart__quantity-selector').val();
var value = parseInt(value) + parseInt(1);
$(this).parents('.quant_div').find('.cart__quantity-selector').val(value);
 $(this).parents('.plus-minus-update').next('.udpate_clas').trigger('click');
})
        
        
        
        jQuery.getJSON('/cart.js', function(cart) {
           var cart_total_item = cart.item_count;
        $('.cart-count').html(cart_total_item);
        } );
        
//       $(document).on("focusout",".quant_div .cart__quantity-selector",function(){
//         $(this).next('.udpate_clas').trigger('click');
//     });
        
        $(document).on('click', '.close-cart-img', function(){
          $('.cart-overlays').hide();
          $('.mini_cart').addClass('extras');
        });
       
      },

    });

  });
 });  

//   $('a.cart-page-link').click(function(){
//     $('.mini_cart').toggle();
//   })


  
  
$(document).on("click",".udpate_clas",function(e) {
  e.preventDefault();
  updateItem( $(this) );
});


$(document).on("click",".plus_udpate_clas",function(e) {
  e.preventDefault();
  updateItem( $(this) );
});

$(document).on("click",".minus_udpate_clas",function(e) {
  e.preventDefault();
  updateItem( $(this) );
});

// attach this function to the event handler
function updateItem(update) {
  var productId = parseInt($(update).attr('data-id'));
  // ajax post to update cart
  var quantity =  $('.cart__quantity-selector').val();
  console.log(productId);

  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: 'quantity='+quantity+'&id=' + productId,
    async: false
  }).done(function(data, textStatus, jqXHR) {
   
    var cart_total_item = data.item_count;
    $('.cart-count').html(cart_total_item);
    min_cart();
    
    $('.minus_udpate_clas').click(function(){
 var value = $(this).parents('.quant_div').find('.cart__quantity-selector').val();
      if(value > 1){
var value = parseInt(value) - parseInt(1);
$(this).parents('.quant_div').find('.cart__quantity-selector').val(value);
    $(this).parents('.plus-minus-update').next('.udpate_clas').click();
      }
})
  
  $('.plus_udpate_clas').click(function(){
var value = $(this).parents('.quant_div').find('.cart__quantity-selector').val();
var value = parseInt(value) + parseInt(1);
$(this).parents('.quant_div').find('.cart__quantity-selector').val(value);
 $(this).parents('.plus-minus-update').next('.udpate_clas').click();
})
    
    
    
    $(document).on('click', '.close-cart-img', function(){
      $('.cart-overlays').hide();
      $('.mini_cart').addClass('extras');
    });

  });
}

  
  
  
  


$(document).on("click",".miniremove_item",function(e) {
        e.preventDefault();
        removeItem( $(this) );
      });

    
        // attach this function to the event handler
    function removeItem(remove) {
        var productId = parseInt($(remove).attr('data-id'));
      // ajax post to update cart
      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: "json",
        data: 'quantity=0&id=' + productId,
        async: false
      }).done(function(data, textStatus, jqXHR) {
        var cart_total_item = data.item_count;
        $('.cart-count').html(cart_total_item);
  min_cart();
       
     
        $('.minus_udpate_clas').click(function(){
 var value = $(this).parents('.quant_div').find('.cart__quantity-selector').val();
          if(value > 1){
var value = parseInt(value) - parseInt(1);
$(this).parents('.quant_div').find('.cart__quantity-selector').val(value);
    $(this).parents('.plus-minus-update').next('.udpate_clas').trigger('click');
          }
})
  
  $('.plus_udpate_clas').click(function(){
var value = $(this).parents('.quant_div').find('.cart__quantity-selector').val();
var value = parseInt(value) + parseInt(1);
$(this).parents('.quant_div').find('.cart__quantity-selector').val(value);
 $(this).parents('.plus-minus-update').next('.udpate_clas').trigger('click');
})
        
      });
    }




// mini cart function here  
  function min_cart(){
  $.ajax({
    url: '/cart',
    success: function(data) {
      $('.mini_cart').html('');
      var cart1 = $(data).find('.mini_cart .cart_data');
      
      $('.mini_cart').html(cart1);
      var cart_total_item = data.item_count;
        $('.cart-count').html(cart_total_item);
       $('.close-cart-img').click(function(){
          $('.cart-overlays').hide();
          $('.mini_cart').addClass('extras');
        })
       $('.minus_udpate_clas').click(function(){
 var value = $(this).parents('.quant_div').find('.cart__quantity-selector').val();
         if(value > 1){
var value = parseInt(value) - parseInt(1);
$(this).parents('.quant_div').find('.cart__quantity-selector').val(value);
    $(this).parents('.plus-minus-update').next('.udpate_clas').trigger('click');
         }
})
  
  $('.plus_udpate_clas').click(function(){
var value = $(this).parents('.quant_div').find('.cart__quantity-selector').val();
var value = parseInt(value) + parseInt(1);
$(this).parents('.quant_div').find('.cart__quantity-selector').val(value);
 $(this).parents('.plus-minus-update').next('.udpate_clas').trigger('click');
})
       
       
       
    }
  });  
}
/************************************ Announcement Bar ***************************/
setTimeout(function(){  
$('.header-announce').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  infinite: false,
  arrows:true,
   adaptiveHeight: true,
    prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left'></i></button>",
 nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right'></i></button>"
});
 }, 1200); 


// Mobile fixed add to cart button js

if ($(window).width() < 779) 
   {
     setTimeout(function(){ 
      $('.swatch-element').click(function(){
         var price= $(this).attr('data-price');
         $('#fixed-button-price').html(price);
      });
      }, 500);   
   }
else
    {

    }

  console.log('AMLA', window.location.href);
var link = 'https://womku5hrdoe7pggs-32102416515.shopifypreview.com/products_preview?preview_key=12d0c21bb2185f819c2c4eceffd59b7d';
var urlMatches = window.location.href === link;
console.log(urlMatches);
if (urlMatches) {
   window.location.href = 'https://joyjolt.com/collections/star-wars-glasses';
}
